<template>
  <div>
    <AuBreadcrumb :pages="breadcrumb" />
    <div class="card">
      <!-- SYSTEM WALLET -->
      <div v-if="enableSystemWallets && !isUserWallet">
        <template v-if="!isSystemWallet && !verifySystemWalletSuccess">
          <!-- Выбор типа кошелька -->
          <div class="title">
            {{ $t("walletVerification.title_wallet_connect") }}
          </div>
          <div>{{ $t("walletVerification.wallet_generate") }}</div>

          <div class="info-wallet">
            <div
              class="option"
              @click="isUserWallet = true"
            >
              <img
                class="icon-list"
                src="/img/us_wallet.svg"
                alt="logo wallet"
              >
              <div class="wallet-name">
                <div>
                  {{ $t("walletVerification.wallet_user") }}
                </div>
                <span class="small-label mt-1">{{
                  $t("walletVerification.wallet_label_1")
                }}</span>
              </div>
            </div>
            <div
              class="option"
              @click="isSystemWallet = true"
            >
              <img
                class="icon-list"
                src="/img/sys_wallet.svg"
                alt="logo wallet"
              >
              <div class="wallet-name">
                <div>
                  {{ $t("walletVerification.wallet_system") }}
                </div>
                <span class="small-label mt-1">{{
                  $t("walletVerification.wallet_label_3", {platform})
                }}</span>
              </div>
            </div>
          </div>
        </template>

        <!-- Генерация системного кошелька -->
        <template v-else-if="isSystemWallet && !arrEth[0]?.value">
          <div class="title">
            {{ $t("walletVerification.wallet_system_generate") }}
          </div>
          <div>{{ $t("walletVerification.wallet_access", { platform }) }}</div>

          <div class="d-flex flex-column mt-4">
            <div
              v-if="errorSystemWallet"
              class="err"
            >
              {{ errorSystemWallet }}
            </div>
            <AuButton
              type="primary"
              center
              width="200px"
              :color-spiner="'#FFFFFF'"
              :is-progress="progressBtn"
              @click="Generate"
            >
              {{ $t("walletVerification.generate") }}
            </AuButton>
          </div>

          <div class="select-wallet">
            <span
              class="wallet-link"
              @click="clearWallet"
            >
              {{ $t("walletVerification.wallet_go_back") }}
            </span>
          </div>
        </template>

        <!-- Верификация системного кошелька -->
        <template v-else-if="verifySystemWalletSuccess || arrEth[0]?.value">
          <div class="title">
            {{ $t("walletVerification.title_2") }}
          </div>
          <VerificationSuccess
            :platform="platform"
            :is-issuer="isIssuer"
            :left-text="leftButtonText"
            :right-text="rightButtonText"
            @gotoPage="gotoPage"
            @gotoCreate="gotoCreate"
          />
        </template>
      </div>

      <!-- USER WALLET -->
      <div v-else>
        <!-- Заголовки -->
        <div
          v-if="isMultiWallet"
          class="title"
        >
          <span>
            {{ $t("walletVerification.alert_5") }}
          </span>
        </div>
        <div
          v-else
          class="title"
        >
          <span v-if="!checkVerifySuccess && walletName !='MetaMask'">
            {{ $t("walletVerification.title_1") }}
          </span>
          <span v-if="!checkVerifySuccess && walletName == 'MetaMask'">
            {{ $t("walletVerification.title_1_1") }}
          </span>
          <span v-if="checkVerifySuccess">
            {{ $t("walletVerification.title_2") }}
          </span>
        </div>

        <!-- Алерты -->
        <Alerts
          :account-address="accountAddress"
          :arr-eth="arrEth"
          :eth-exists="ethExists"
        />

        <!-- Нет провайдера -->
        <template v-if="!isProviderExist">
          <div class="subtitle">
            <div>
              {{ $t("walletVerification.subtitle_1") }}
            </div>
            <div class="mt-4">
              {{ $t("walletVerification.subtitle_2") }}
            </div>
          </div>

          <a
            class="button-link"
            href="https://metamask.io/download"
            target="_blank"
          >
            <AuButton
              class="mt-2"
              type="primary"
              center
              width="200px"
            >
              <div class="btn_metamask">
                {{ $t("walletVerification.btn_1") }}
              </div>
            </AuButton>
          </a>
        </template>

        <!-- Мульти-кошельки -->
        <template v-else-if="isMultiWallet">
          <div>{{ $t("walletVerification.alert_6") }}</div>
          <div>{{ $t("walletVerification.alert_7") }}</div>

          <div
            v-for="(prov, index) in providersOptions"
            :key="index"
            class="select-list"
            :class="{ 'select-hover': hovered[index] }"
            @click="setProvider(index)"
            @mouseenter="hovered[index] = true"
            @mouseleave="hovered[index] = false"
          >
            <img
              class="icon-list"
              :src="prov.icon"
              alt="logo wallet"
            >
            <span>{{ prov.display }}</span>
          </div>

          <div class="select-wallet">
            <span
              class="wallet-link"
              @click="clearWallet"
            >
              {{ $t("walletVerification.wallet_go_back") }}
            </span>
          </div>
        </template>
      </div>
      <!-- Установлен MetaMask -->
      <div v-if="!isMultiWallet">
        <div
          v-if="isProviderExist"
          class="subtitle"
        >
          <!-- Установлен - Не подключен -->
          <div
            v-if="!accountAddress && !checkVerifySuccess"
            class="subtitle"
          >
            <div>
              {{ $t("walletVerification.subtitle_3") }}
            </div>
            <div v-if="!statusConnection">
              {{ $t("walletVerification.subtitle_4") }}
            </div>
            <div v-if="statusConnection">
              {{ $t("walletVerification.subtitle_5") }}
            </div>
            <div
              v-if="satusOpenWallet && statusConnection"
              class="mt-4"
            >
              {{ $t("walletVerification.subtitleNote2") }}
            </div>
            <div v-if="satusOpenWallet && statusConnection">
              {{ $t("walletVerification.subtitleNote3") }}
            </div>

            <div
              v-if="isMobile"
              class="mt-4"
            >
              <div>
                {{ $t("walletVerification.mobile1") }}
              </div>
              <div>
                {{ $t("walletVerification.mobile2") }}
              </div>
            </div>

            <AuButton
              class="mt-4"
              type="primary"
              center
              width="200px"
              @click="connectWallet"
            >
              <div class="btn_metamask">
                <div>
                  {{ $t("walletVerification.btn_2") }}
                </div>
              </div>
            </AuButton>
          </div>

          <!-- MetaMask -->
          <template v-else>
            <!-- Не подключен -->
            <ConnectWallet
              v-if="!accountAddress && !checkVerifySuccess"
              :status-connection="statusConnection"
              :satus-open-wallet="satusOpenWallet"
              @connectWallet="connectWallet"
            />

            <!-- Подключен, кошельки не совпадают -->
            <WalletChange
              v-else-if="checkChange"
              :account-address="accountAddress"
              :status-change="statusChange"
              @openMetamaskAction="openMetamaskAction"
            />

            <!-- Подключен, совпадают -->
            <WalletVerify
              v-else-if="accountAddress && !arrEth[0]?.status"
              :account-address="accountAddress"
              :satus-sign="satusSign"
              @startVerify="startVerify"
            />

            <!-- Верифицирован -->
            <VerificationSuccess
              v-else-if="checkVerifySuccess"
              :platform="platform"
              :is-issuer="isIssuer"
              :left-text="leftButtonText"
              :right-text="rightButtonText"
              @gotoPage="gotoPage"
              @gotoCreate="gotoCreate"
            />
          </template>

          <!-- Подпись текущего провайдера -->
          <div
            v-if="walletName"
            class="select-wallet"
          >
            <span>{{
              $t("walletVerification.alert_8") + " " + walletName
            }}</span>
            <span
              class="wallet-link"
              @click="clearProvider"
            >
              {{ $t("walletVerification.another") }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import AuButton from "@/components/extended/AuButton.vue";
import MetaMask from "@/mixins/MetaMask";
import { mapActions, mapGetters } from "vuex";

// Вынес переиспользуемые блоки
import Alerts from "@/components/wallet/Alerts.vue";
import ConnectWallet from "@/components/wallet/ConnectWallet.vue";
import VerificationSuccess from "@/components/wallet/VerificationSuccess.vue";
import WalletChange from "@/components/wallet/WalletChange.vue";
import WalletVerify from "@/components/wallet/WalletVerify.vue";

export default {
  name: "Verification",
  components: {
    AuButton,
    Alerts,
    ConnectWallet,
    WalletChange,
    WalletVerify,
    VerificationSuccess
  },
  mixins: [MetaMask],

  data() {
    return {
      isUserWallet: false,
      isSystemWallet: false,
      verifySystemWalletSuccess: false,
      errorSystemWallet: null,
      ethExists: false,
      satusSign: false,
      satusOpenWallet: false,
      walletName: "",
      provider: null,
      wallets: [],
      hovered: null,
      breadcrumb: [
        { key: 0, name: this.$t("router.pages.dashboard"), path: "/" }
      ]
    };
  },

  computed: {
    ...mapGetters({
      arrEth: "ethAddresses",
      accountAddress: "accountAddress",
      companyCount: "companyCount"
    }),

    enableSystemWallets() {
      return process.env.VUE_APP_ENABLE_SYSTEM_WALLETS == "true";
    },
    platform() {
      return process.env.VUE_APP_PLATFORM;
    },

    isMultiWallet() {
      return !this.provider && this.wallets.length > 1;
    },

    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },

    isProviderExist() {
      return window?.ethereum || this.isMobile;
    },

    providersOptions() {
      return this.isMultiWallet
        ? this.wallets.map((wallet, index) => ({
          display: wallet.info.name,
          value: index,
          icon: wallet.info.icon
        }))
        : [];
    },

    checkVerifySuccess() {
      return (
        this.arrEth[0]?.value &&
        this.arrEth[0]?.status &&
        this.arrEth[0]?.verifiedAt
      );
    },

    checkChange() {
      return (
        (this.accountAddress &&
          this.arrEth[0]?.value &&
          this.accountAddress !== this.arrEth[0]?.value) ||
        this.ethExists
      );
    },

    isIssuer() {
      return this.$auth.user().type == "issuer";
    },

    leftButtonText() {
      return this.$t("walletVerification.btn_" + (this.isIssuer ? "6" : "8"));
    },

    rightButtonText() {
      return this.$t(
        "walletVerification.btn_" +
          (this.isIssuer ? (this.companyCount > 0 ? "5" : "7") : "6")
      );
    }
  },

  watch: {
    accountAddress() {
      this.ethExists = false;
      this.btnSignIn = true;
    }
  },

  mounted() {
    window.addEventListener("eip6963:announceProvider", (e) =>
      this.wallets.push(e.detail)
    );
    window.dispatchEvent(new Event("eip6963:requestProvider"));
    this.hovered = _.map(this.wallets, () => false);
  },

  methods: {
    ...mapActions({
      postEthAddresses: "postEthAddresses",
      getEthAddresses: "getEthAddresses",
      getValidateContent: "getValidateContent",
      signAndVerify: "signAndVerify",
      patchEthAddresses: "patchEthAddresses",
      generateSystemWallet: "profile/generateSystemWallet"
    }),

    async connectWallet() {
      this.provider = this.provider ?? window.ethereum;
      await this.startWallet(this.provider);
      try {
        await this.connectMetamaskAction();
        this.satusOpenWallet = false;
      }
      catch {
        this.satusOpenWallet = true;
      }
    },

    setProvider(index) {
      this.provider = this.wallets[index].provider;
      this.startWallet(this.provider);
      this.walletName = this.wallets[index].info.name;
    },

    clearProvider() {
      this.hovered = _.map(this.walletName, () => false);
      this.walletName = "";
      this.provider = null;
      this.accountAddress = null;
      this.statusConnection = true;
    },

    clearWallet() {
      this.isUserWallet = false;
      this.isSystemWallet = false;
      this.verifySystemWalletSuccess = false;
      this.errorSystemWallet = null;
    },

    gotoPage(url) {
      this.$router.push({ name: url });
    },
    gotoCreate() {
      let url = "/my-assets/buy-form";
      if (this.isIssuer) {
        url =
          this.companyCount > 0
            ? "/my-projects/edit-project/new"
            : "/companies/company-manager";
      }
      this.$router.push(url);
    },

    async Generate() {
      this.progressBtn = true;
      try {
        await this.generateSystemWallet();
        this.verifySystemWalletSuccess = true;
        this.isSystemWallet = false;
        this.errorSystemWallet = null;
        await this.getEthAddresses();
      }
      catch (error) {
        this.errorSystemWallet = error?.response?.data?.message;
      }
      finally {
        this.progressBtn = false;
      }
    },

    sendCarrot(address) {
      if (window.carrotquest && process.env.VUE_APP_CARROT_ENABLED === "true") {
        window.carrotquest.track("metamask assigned", { address });
        window.carrotquest.identify([
          { op: "update_or_create", key: "metaMaskWallet", value: address }
        ]);
      }
    },

    async addEth() {
      const id = this.$auth.user().id;
      try {
        const resp = await this.postEthAddresses({
          value: this.accountAddress.toLowerCase(),
          user: `/api/users/${id}`
        });
        if (resp?.data.message) {
          this.$toast.warning(resp?.data.message);
          this.ethExists = resp?.data.message.includes("exists");
          this.satusSign = false;
        }
        if ([200, 201].includes(resp?.status)) {
          await this.getEthAddresses();
          this.ethExists = false;
          this.validateAddress();
        }
      }
      catch (error) {
        console.error("Error_addEth", error);
        this.satusSign = false;
        await this.getEthAddresses();
        this.$toast.error(error?.message);
      }
    },

    startVerify() {
      this.satusSign = true;
      if (
        this.arrEth[0]?.value &&
        this.accountAddress === this.arrEth[0]?.value
      ) {
        this.validateAddress();
      }
      else {
        this.addEth();
      }
    },

    async validateAddress() {
      const currentAddress = this.arrEth[0]?.value.toLowerCase();
      try {
        const data = await this.getValidateContent(currentAddress);
        const sign = await this.web3.eth.personal.sign(
          data.content,
          currentAddress,
          ""
        );
        const result = await this.signAndVerify({
          accountAddress: currentAddress,
          sign
        });

        if (result.result) {
          this.$toast.success(this.$t("validate.success"));
          this.sendCarrot(this.accountAddress.toLowerCase());
          await this.getEthAddresses();
        }
        else {
          this.$toast.error(this.$t("validate.error"));
        }
      }
      catch (error) {
        console.error("Error_validateAddress", error);
        if (error?.response?.data?.message) {
          await this.getEthAddresses();
          this.$toast.error(error?.response?.data?.message);
        }
      }
      finally {
        this.satusSign = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  padding: 20px;
  border-radius: 12px;
}

.title {
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 30px;
}

.subtitle {
  font-size: 14px;
}

.btn_metamask {
  display: flex;
  justify-content: center;
  align-items: center;
}

.metamask {
  background: url(../assets/img/metamask_big.png) center/cover no-repeat;
  padding: 8px;
  margin-right: 10px;
}

.link {
  color: #ffffff;
}

.button-link {
  display: inline-block;
  text-decoration: none;
}

.select-list {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
  cursor: pointer;
  width: 350px;
  padding: 10px;

  .icon-list {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
}

.select-wallet {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  gap: 10px;

  .wallet-link {
    color: #2aba7c;
    text-decoration: underline;
    cursor: pointer;
  }
}

.select-hover {
  background: var(--color-70);
}

.info-wallet {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.option {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 500px;
  padding: 10px;
  cursor: pointer;

  .icon-list {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
  &:hover {
    background: var(--color-70);
  }
}

.err {
  margin-bottom: 10px;
  color: red;
}

.wallet-name {
  padding-top: 6px;
}

.small-label {
  display: flex;
  color: var(--color-50);
  font-size: 10px;
}
</style>
